// extracted by mini-css-extract-plugin
export default {"label":"Q970qt"};